<div
	class="row"
	*ngIf="loading">
	<div class="col text-center">
		<app-loader [material]="false"></app-loader>
	</div>
</div>
<div class="row">
	<div class="col">
		<div class="grey-bg">
			<a
				class="float-right btn btn-sm btn-primary"
				(click)="edit()"
				*ngIf="project?.isDraft">
				<i
					container="body"
					ngbTooltip="{{'labels.create' | translate}}"
					class="feather icon-plus"></i>
			</a>
		</div>
	</div>
</div>

<div class="row">

	<div
		class="col-sm-12 loading"
		*ngIf="loading">
		<div class="grey-bg">
			<i class="fa fa-circle-notch fa-spin fa-2x fa-fw"></i>
		</div>
	</div>

	<div class="col-12 card-list-container">
		<div class="grey-bg">

			<div
				class="card card-list-element"
				*ngFor="let item of deliverables">

				<div class="card-body">
					<div class="row">
						<div class="col-5">
							<strong class="card-title">{{item.name}}</strong>

							<span
								class="attachment"
								*ngIf="item.attach">
								{{item.attach.filename}} ({{item.attach.size | fileSize }})
								<el-attachment-preview
									[attach]="item?.attach"
									mediapath="download"></el-attachment-preview>
							</span>
							<!-- <span class="filetype">{{item.deltype}}</span> -->
						</div>
						<div class="col-4">
							<div class="deliverable-milestone">
								Milestone:
								<br>
								<b *ngIf="item['milestone']">{{item['milestone']['name']}}</b>
							</div>
						</div>
						<div class="icon-buttons col-3 text-right">
							<a
								[ngbTooltip]="'labels.edit' | translate"
								(click)="edit(item)"
								*ngIf="project?.isDraft && !usercompanyid">

								<i class="feather icon-edit"></i>
							</a>
							<a
								[ngbTooltip]="'labels.download' | translate"
								*ngIf="item.attach"
								(click)="download(item.attach)">

								<i class="feather icon-download"></i>
							</a>
							<a
								[ngbTooltip]="'labels.dochistory' | translate"
								*ngIf="item.attach"
								(click)="dochistory(item)">

								<i class="feather icon-clock"></i>
							</a>
							<a
								[ngbTooltip]="'labels.delete' | translate"
								(click)="delete(item)"
								*ngIf="project?.isDraft && !usercompanyid">

								<i class="feather icon-trash"></i>
							</a>
						</div>
					</div>
				</div>
			</div>

			<div
				class="card-body card"
				*ngIf="!deliverables.length && !loading">
				<div class="row">
					<div class="col-12 text-center">
						<div class="append-bottom-5">
							<strong>
								{{'labels.none-deliverable' | translate}}
							</strong>
						</div>

					</div>
				</div>

			</div>

		</div>
	</div>
</div>
